<div class="gradientTheme errorPageContent">
  <div class="container">
    <img [src]="logoPath" alt="gatho-logo" class="gathoLogo" />
    <h4 class="is-light text-center">
      {{ errorMessage }}
    </h4>
    <a routerLink="/" mat-stroked-button> HOME </a>
  </div>
</div>
